import {
  faArrowRightFromBracket,
  faChartSimple,
  faChevronLeft
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonPage,
  IonProgressBar,
  IonRow,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import "./NextGame.scss";
import { useEffect, useState } from "react";
import Glide from "@glidejs/glide";
import coffeeTools from "../../CoffeeTools";
import lnbp_logo from "../../icon/icon.png";
import video_play_icon from "../../icon/8_B_Video.png";

const NextGame: React.FC<{
  game: { team_1; team_2; date; time; score_1; score_2 };
}> = ({ game }) => {
  //   const [showProgessBar, setShowProgessBar] = useState(true);
  let base_url = process.env.REACT_APP_BASE_URL;
  let coffee_tools = new coffeeTools();

  //declared outside to make it global and used it on the page

  useEffect(() => {
    // show slider
    //start the page
    let coffee = new coffeeTools();
    // console.log(coffee.test(123));
  }, []);

  // tools and helpers
  function createSectionTitles(title, dom_obj_id) {
    let container = document.getElementById(dom_obj_id);
    container.innerHTML = "";
    coffee_tools.createSectionTitle(title, container);
  }

  return (
    <div
      style={{
        height: "10.5rem",
        boxShadow: "0 0 0.5rem 0.1rem rgba(0, 0, 0, 0.1)",
        borderRadius: "0.5rem",
        flex: "0 0 auto",
        width: "6rem",
        textAlign: "center",
        padding: "0.5rem",
        margin: "0.5rem"
      }}
    >
      <div style={{ marginBottom: "0.1rem" }}>
        <img
          src={base_url + game.team_1}
          alt='Team 1 logo'
          style={{ width: "3rem", backgroundColor: "white" }}
        />
        <span> {game.score_1 !== 0 ? game.score_1 : ""} </span>
      </div>
      <div style={{ marginBottom: "0.2rem" }}>
        <img
          src={base_url + game.team_2}
          alt='Team 2 logo'
          style={{ width: "3rem", backgroundColor: "white" }}
        />
        <span> {game.score_2 !== 0 ? game.score_2 : ""} </span>
      </div>

      <div style={{ marginBottom: "0.5rem" }}>
        {game.date.substring(5).replace("-", "/")}
      </div>

      <div>{game.time.substring(0, 5)}</div>
    </div>
  );
};

export default NextGame;
